/**
 * Copyright © 2026 Adnuntius AS.
 * UI-Router state declarations.
 */
import {Ng2StateDeclaration} from '@uirouter/angular';
import {collectStatesFromProvider, AdnRouterHelperApi} from '../routing/state-utils';
import {RouteTwoPanelLayoutComponent} from '../common/directives/route-two-panel-layout.component';
import {LineItemListContextActionsComponent} from './line-item-list-context-actions.component';
import {LineItemContextActionsComponent} from './line-item-context-actions.component';
import {AdminResourceItemRoutePageComponent} from '../common/controller/admin-resource-item-route-page.component';
import {CreativeResource} from '../../components/api/resources/resource/creative.resource';
import {LineItemResource} from '../../components/api/resources/resource/line-item.resource';

const listTemplate = '<adn-line-item-list-page [list]="list"></adn-line-item-list-page>';



export function lineItemStates(adnRouterHelper: AdnRouterHelperApi): Ng2StateDeclaration[] {
  return collectStatesFromProvider(function register($stateProvider, adnRouterHelperProvider) {
const rh = adnRouterHelperProvider.$get().createRouterAndChildHelper('line-items.line-item', LineItemResource, CreativeResource, 'app.adv', 'app', listTemplate);
        $stateProvider.state(rh.listPath(), rh.list({
          resolve: {
            listConfig: function() {
              return {};
            },
            bulk: function() {
              return {};
            },
            sectionParam: function() {
              return 'lineItems';
            },
            model: function() {
              return {};
            },
            modelComms: function() {
              return {};
            }
          },
          views: {
            'context@app': {
              component: LineItemListContextActionsComponent,
              bindings: {
                model: 'model',
                modelComms: 'modelComms',
                readOnly: 'listReadOnly',
                sectionParam: 'sectionParam'
              }
            }
          }
        }))
          .state(rh.newItemPath(), rh.newItem())
          .state(rh.itemPath(), rh.modelCommsItem({
            resolve: {
              advertiserFromParam: /*@ngInject*/ function($stateParams) {
                if ($stateParams.advertiserId && $stateParams.advertiserName) {
                  return {
                    id: $stateParams.advertiserId,
                    name: $stateParams.advertiserName
                  };
                }
              },
              orderFromParam: /*@ngInject*/ function($stateParams) {
                if ($stateParams.orderId && $stateParams.orderName) {
                  return {
                    id: $stateParams.orderId,
                    name: $stateParams.orderName
                  };
                }
              },
              lineItemView: /*@ngInject*/ function($stateParams) {
                const dataViewResource = adnRouterHelper.services.dataViewResource();

                if (!$stateParams.isNew) {
                  const lineItemId = $stateParams.id || 'undefined-id';
                  return dataViewResource.get('LineItemView', {id: lineItemId}, false).catch(function() {
                    return null;
                  });
                }
              },
              full: /*@ngInject*/ function($stateParams) {
                return !!$stateParams.full;
              },
              viewType: /*@ngInject*/ function($stateParams) {
                return $stateParams.viewType === 2 ? 2 : 1;
              },
              leftPanelFull: function() {
                return false;
              },
              leftPanelPartAFull: function() {
                return true;
              },
              lineItemEditRouteKey: function() {
                return 'line-item-edit';
              },
              lineItemAnalysisRouteKey: function() {
                return 'line-item-analysis-edit';
              },
              routeEditVariant: function() {
                return 'edit';
              },
              lineItemLeftInputs: /*@ngInject*/ function(
                viewType, orderFromParam, advertiserFromParam, lineItemView
              ) {
                return {full: false, viewType, orderFromParam, advertiserFromParam, lineItemView};
              },
              lineItemLeftFullInputs: /*@ngInject*/ function(
                viewType, orderFromParam, advertiserFromParam, lineItemView
              ) {
                return {full: true, viewType, orderFromParam, advertiserFromParam, lineItemView};
              },
              lineItemAnalysisInputs: /*@ngInject*/ function(lineItemView) {
                return {lineItemView};
              },
              model: /*@ngInject*/ function($stateParams) {
                if ($stateParams.isNew) {
                  return adnRouterHelper.services.resource(LineItemResource).create({
                    id: $stateParams.id,
                    userState: 'RESERVED'
                  });
                }
                return adnRouterHelper.services.resource(LineItemResource).get({id: $stateParams.id || 'undefined-id'}).$promise;
              }
            },
            views: {
              'content@app': {
                component: RouteTwoPanelLayoutComponent,
                bindings: {full: 'full', modelComms: 'modelComms'}
              },
              'rightPanel@app.adv.line-items.line-item': {
                component: AdminResourceItemRoutePageComponent,
                bindings: {
                  item: 'lineItemAnalysisRouteKey',
                  variant: 'routeEditVariant',
                  inputOverrides: 'lineItemAnalysisInputs'
                }
              },
              'leftPanel@app.adv.line-items.line-item': {
                component: AdminResourceItemRoutePageComponent,
                bindings: {
                  item: 'lineItemEditRouteKey',
                  variant: 'routeEditVariant',
                  inputOverrides: 'lineItemLeftInputs'
                }
              },
              'leftPanelPartA@app.adv.line-items.line-item': {
                component: AdminResourceItemRoutePageComponent,
                bindings: {
                  item: 'lineItemEditRouteKey',
                  variant: 'routeEditVariant',
                  inputOverrides: 'lineItemLeftFullInputs'
                }
              },
              'context@app': {
                component: LineItemContextActionsComponent,
                bindings: {
                  model: 'model', modelComms: 'modelComms', isNew: 'isNew',
                  readOnly: 'readOnly', viewType: 'viewType'
                }
              }
            }
          }, 'LineItem', [{type: 'Advertiser', func: 'canBeShownAdvertiser'}, {type: 'Order', func: 'isNotSelfService'}]));
  }, adnRouterHelper);
}
